import { CategoryChip, HotTag } from "./Shared";
import { FEED_ITEMS, HERO_STORY } from "../../../mocks/gossip";

export default function Hero() {
  const quick = FEED_ITEMS.slice(0, 4);
  return (
    <section className="w-full" aria-label="今日头条">
      <div className="container-x pt-5 md:pt-8">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* featured big story */}
          <article className="lg:col-span-8">
            <a
              href="#feature"
              className="group relative block h-[420px] w-full overflow-hidden rounded-2xl md:h-[520px]"
            >
              <img
                src={HERO_STORY.image}
                alt={HERO_STORY.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-foreground-950/10" />
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                <div className="mb-3 flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-semibold text-background-50">
                    <i className="ri-flashlight-fill text-[11px]" />
                    刚刚爆 · 头条
                  </span>
                  <CategoryChip label={HERO_STORY.category} toneKey={HERO_STORY.categoryKey} />
                </div>
                <h2 className="text-balance font-heading text-2xl font-black leading-snug text-background-50 md:text-[34px] md:leading-snug">
                  {HERO_STORY.title}
                </h2>
                <p className="mt-3 hidden max-w-3xl text-sm leading-6 text-background-100/90 sm:block md:text-base">
                  {HERO_STORY.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-background-100/80">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line" />
                    {HERO_STORY.time}
                  </span>
                  <span className="flex items-center gap-1.5 text-accent-300">
                    <i className="ri-fire-line" />
                    {HERO_STORY.heat}
                  </span>
                  <span className="ml-auto hidden items-center gap-1 rounded-full bg-background-50/15 px-3 py-1.5 text-background-50 transition-colors group-hover:bg-primary-500 sm:flex">
                    读全文，追进展 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          </article>

          {/* quick 今日速递 */}
          <aside className="lg:col-span-4" aria-label="今日速递快报">
            <div className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-100/60 p-4 md:p-5">
              <div className="mb-3 flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                  <span className="inline-block h-5 w-1 rounded-full bg-accent-500" />
                  今日速递
                </h2>
                <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800">
                  <i className="ri-radio-button-line animate-pulse" />
                  实时
                </span>
              </div>
              <ul className="flex flex-1 flex-col divide-y divide-background-200/80">
                {quick.map((item) => (
                  <li key={item.id}>
                    <a href="#today" className="group flex gap-3 py-3">
                      <span className="mt-0.5 font-label text-sm font-bold text-primary-500">
                        {String(item.id).padStart(2, "0")}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="line-clamp-2 text-sm font-medium leading-5 text-foreground-800 transition-colors group-hover:text-primary-600">
                          {item.title}
                        </p>
                        <div className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                          <span>{item.time}</span>
                          <HotTag label={item.hot} tone={item.hot === "爆" ? "boom" : item.hot === "热" ? "hot" : "new"} />
                        </div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
              <a
                href="#today"
                className="mt-1 flex items-center justify-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-4 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-50 hover:text-primary-700"
              >
                查看更多今日新瓜 <i className="ri-arrow-down-s-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}